import { useState } from "react";
import "./App.css";
import PathFinding from "./pathFinding/pathFinding";
import Sorting from "./sorting/sorting";

function App() {
  const [activeTab, setActiveTab] = useState<'sorting' | 'pathfinding'>('pathfinding');

  return (
    <div className="app-container">
      <main className="app-content">
        <div className="visualizer-container">
          <nav className="tab-navigation">
            <button 
              className={`tab-button ${activeTab === 'pathfinding' ? 'active' : ''}`}
              onClick={() => setActiveTab('pathfinding')}
            >
              Path Finding
            </button>
            <button 
              className={`tab-button ${activeTab === 'sorting' ? 'active' : ''}`}
              onClick={() => setActiveTab('sorting')}
            >
              Sorting
            </button>
          </nav>
          
          {activeTab === 'pathfinding' ? (
            <PathFinding />
          ) : (
            <Sorting />
          )}
        </div>
      </main>
    </div>
  );
}

export default App;
